import { render } from "./EveryoneSocialCollectionSettings.vue?vue&type=template&id=397a05c3&scoped=true"
import script from "./EveryoneSocialCollectionSettings.vue?vue&type=script&lang=js"
export * from "./EveryoneSocialCollectionSettings.vue?vue&type=script&lang=js"

import "./EveryoneSocialCollectionSettings.vue?vue&type=style&index=0&id=397a05c3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-397a05c3"]])

export default __exports__